// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_1M-R0","productBadge":"_1WPzN","badge":"_3S5u4","defaultImage":"dImJ9"};